import { useAuthStore } from '@/store/auth-store';

type Session = Pick<ReturnType<typeof useAuthStore.getState>, 'token' | 'user' | 'impersonation'>;

/** Cache/request identity only; authorization is always enforced by the API. */
export function sessionScope(session: Session): string {
  if (!session.token) return 'anonymous';
  let tenant = '';
  try {
    const payload = session.token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    tenant = JSON.parse(atob(payload)).tenant_id ?? '';
  } catch { /* Opaque test/legacy tokens still have a user identity. */ }
  return JSON.stringify([session.user?.id, tenant, session.impersonation?.tenantId]);
}

/** Request/cache ownership only. This is never an authorization decision. */
export function sessionTenantId(session: Session): string {
  const scope = sessionScope(session);
  if (scope === 'anonymous') return '';
  const tenant: unknown = JSON.parse(scope)[1];
  return typeof tenant === 'string' ? tenant : '';
}

let revision = 0;
useAuthStore.subscribe((next, previous) => {
  if (sessionScope(next) !== sessionScope(previous)) revision++;
});
export const sessionRevision = () => revision;
export function requireCurrentSession(expected: number): void {
  if (expected !== revision) throw new DOMException('La sesión cambió', 'AbortError');
}
